import React from 'react';
import PropTypes from 'prop-types';
import TextInputField from './TextInputField';

const PressContactInput = ({
  index,
  nameField,
  emailField,
  phoneField,
  onFieldChange,
  onFieldBlur,
  onDelete,
  canDelete,
}) => {
  const handleDelete = () => {
    onDelete(index);
  };

  return (
    <div className="press-contact-info">
      <div className="press-contacts__form__header">
        <span>{index === 0 ? 'Contact person' : `Contact person #${index + 1}`}</span>
        {canDelete && (
          <div className="press-contacts__form__delete">
            <button type="button" onClick={handleDelete}>
              <img className="delete-image" src="/static/images/x_grey.svg" alt="Delete icon" />
              Remove
            </button>
          </div>
        )}
      </div>
      <TextInputField
        className="press-contact-info-name"
        id={nameField.name}
        label="Full name "
        onChange={onFieldChange}
        onBlur={onFieldBlur}
        value={nameField.value}
        errorMsg={nameField.errors}
        touched={nameField.touched}
      />
      <TextInputField
        className="press-contact-info-email"
        id={emailField.name}
        label="Email address "
        onChange={onFieldChange}
        onBlur={onFieldBlur}
        value={emailField.value}
        errorMsg={emailField.errors}
        touched={emailField.touched}
      />
      <TextInputField
        className="press-contact-info-phone"
        id={phoneField.name}
        label="Contact phone number"
        onChange={onFieldChange}
        onBlur={onFieldBlur}
        value={phoneField.value}
        errorMsg={phoneField.errors}
        touched={phoneField.touched}
      />
    </div>
  );
};

PressContactInput.propTypes = {
  index: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  nameField: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  emailField: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  phoneField: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  canDelete: PropTypes.bool.isRequired,
};

export default PressContactInput;
